import { keyframes, styled } from 'styled-components';

const openDrawer = keyframes`
  0% {transform: translateX(-1000px);}
  100% {transform: translateX(0px);}
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 45px 32px 20%;
  margin-left: 20px;
  background-color: ${({ theme }) => theme.neutral_100};
  position: fixed;
  animation: ${openDrawer} 300ms ease-in-out;
  animation-fill-mode: forwards;
  z-index: 2;
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CloseButton = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 100%;
  margin-bottom: 24%;
  background-color: ${({ theme }) => theme.neutral_200};
`;

export const ReceiptTemplate = styled.div`
  width: 100%;
  zoom: 0.7;
`;

export const SignatureContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const Signature = styled.div`
  width: 90%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:before {
    content: '';
    position: absolute;
    top: -8px;
    width: 100%;
    height: 1px;
    background-color: ${({ theme }) => theme.neutral_900};
  }
`;
